<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closeDialog"
      width="1000px"
    >
      <div class="dialog-content lg">
        <el-form ref="form" :rules="rules" :model="form" label-width="160px" style="width: 100%; margin: auto; padding: 30px 0;">
          <el-form-item label="产品名称" prop="cpmc">
            <el-input v-model="form.cpmc" clearable  placeholder="请输入" show-word-limit  />
          </el-form-item>
          <!-- <el-form-item label="利率范围(%)" prop="zgnhlv" style="width: 100%;">
            <el-input-number el-input-number controls-position="right"   v-model="form.zxdklv" style="width: 40%;"  clearable placeholder="请输入"></el-input-number>
            <span style="margin: 0 50px;">~</span>
            <el-input-number el-input-number controls-position="right"   v-model="form.zddklv" style="width: 40%;"  clearable placeholder="请输入"></el-input-number>
          </el-form-item> -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="最低利率(%)" prop="zxdklv">
                  <el-input-number el-input-number controls-position="right"   v-model="form.zxdklv" style="width: 100%;"  clearable placeholder="请输入"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最高利率(%)" prop="zddklv"  >
                <el-input-number el-input-number controls-position="right"   v-model="form.zddklv" style="width: 100%;"  clearable placeholder="请输入"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="贷款额度(万元)" prop="dked">
                <el-input-number el-input-number controls-position="right"  v-model="form.dked" style="width: 100%;"  clearable placeholder="请输入"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="贷款期限(月)" prop="dkqx"  >
                <el-input-number el-input-number controls-position="right"   v-model="form.dkqx"  style="width: 100%;"  clearable placeholder="请输入"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="担保方式" prop="dbfsbm">
                <select-from-dictionary
                  :code="'guaranty'"
                  :placeholder="'担保方式'"
                  :default-val="form.dbfsbm"
                  :cus-style="'width: 300px; margin-right: 10px; display:inline-block'"
                  @change="changeGuaranty"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="信贷类型" prop="xdlxbm">
                <select-from-dictionary
                  :code="'loan'"
                  :placeholder="'信贷类型'"
                  :default-val="form.xdlxbm"
                  :cus-style="'width: 300px; margin-right: 10px; display:inline-block'"
                  @change="changeLoan"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="客户经理" prop="lxrxm">
                  <el-input
                      v-model="form.lxrxm"
                      clearable
                      placeholder="请输入"
                      show-word-limit
                  />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="lxrdh" >
                <el-input
                    v-model="form.lxrdh"
                    clearable
                    placeholder="请输入"
                    show-word-limit
                    maxlength="11"
                />
            </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24"> 
              <el-form-item label="融资用途" prop="rzyt">
                <el-input
                    v-model="form.rzyt"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入内容"
                    clearable
                    maxlength="300"
                    show-word-limit
                />
            </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { uploadFiles } from '@/api/index'
import { validateForm ,validateCellPhone } from '@/utils'
import uEditor from "@/components/uEditor/index";
import {addFinancingNeed ,editorFinancingNeed } from "../viewApi";

export default {
  name: 'Dialog',
  components: { editor: uEditor },
  props: ['showDialog', 'dialogTitle', 'viewData'],
  data () {
    return {
      baseUrl: process.env.VUE_APP_IMG_API,
      form:{
        cpmc:'',
        // images:'',
        dked:'',
        dked:'',

        zxdklv:'',
        zddklv:'',

        dkqx:'',
        dkqx:'',
        dkqx:'',

        dbfs:'',
        dbfsbm:'',

        xdlxbm:'',

        lxrxm:'',
        lxrdh:'',

        rzyt:'',
      },
      rules: {
        cpmc: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        // images: [
        //     { required: true, message: '请上传图标', trigger: ['blur', 'change'] }
        // ],
        dked: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        zxdklv: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        zddklv: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        dkqx: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        dbfsbm: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        xdlxbm: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        lxrxm: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        lxrdh: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
          { validator: validateCellPhone, trigger: ["blur", "change"] },
        ],
        rzyt: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ]
      },
    }
  },
  created () {
    let userInfoweb = this.$store.state.system.userInfoweb;
    this.form.lxrdh = userInfoweb.account;
    this.form.lxrxm = userInfoweb.username;
    console.log('userInfoweb',userInfoweb)
    if (this.viewData&&this.viewData.id) {
      this.form = {image: this.viewData.path , ...this.viewData};
    }
  },
  mounted() {

  },
  methods: {
    changeGuaranty(data){
      this.form.dbfs = data.dictionaryKey;
      this.form.dbfsbm = data.code;
    },
    changeLoan(data){
      this.form.xdlxbm = data.code;
      this.form.xdlx = data.dictionaryKey;
    },

    // changeEditor (value) {
    //   this.form.rzyt = value;
    // },

    //上传
    uploadedFiles (file) {
        let formData = new FormData();
        formData.append('file', file)  
        uploadFiles(formData).then(( res )=>{
          if(res.data){
            this.form.images = res.data.url;
          }
        })
    },
    handleAvatarSuccess(res, file) {
    },

    // 提交
    async submit () {
      if (!validateForm(this.$refs["form"])) {
        message = "表单信息缺失。";
        this.$baseMessage(message, "error");
        return;
      }
      let res = {}
      let message = ''
      if (this.viewData&&this.viewData.id) {
        this.form.id = this.viewData.id;
        res = await editorFinancingNeed(this.form)
        message = '修改成功。'
      } else {
        res = await addFinancingNeed(this.form)
        message = '新增成功。'
      }
      this.$baseMessage(message, 'success')
      this.$emit('closeDialog', true)
    },
    closeDialog () {
      this.$emit('closeDialog')
    }

  }
}
</script>
<style >
.dialog-footer{
  width: 160px !important;
  height: 50px !important;
  margin: auto !important;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
</style>
